{
  "name": "bonus-management-ui",
  "version": "2026.11.02",
  "type": "module",
  "scripts": {
    "artifactregistry-login": "npx google-artifactregistry-auth",
    "build": "vite build",
    "check-branch-name": "chmod 755 ./hooks/check_branch_naming.sh && sh ./hooks/check_branch_naming.sh",
    "check-npm-audit": "chmod 755 ./hooks/check_npm_audit.sh && sh ./hooks/check_npm_audit.sh",
    "coverage": "vitest run --coverage",
    "docker:build": "docker build -t $npm_config_image .",
    "dev": "vite",
    "format": "prettier --plugin-search-dir . --check .",
    "format:fix": "prettier --plugin-search-dir . --write .",
    "lint": "TIMING=1 eslint --quiet --cache --cache-location .eslintcache .",
    "lint:fix": "TIMING=1 eslint --fix --cache --cache-location .eslintcache .",
    "lint-staged-husky": "lint-staged",
    "ls-lint": "ls-lint",
    "prepare": "husky",
    "preview": "vite preview",
    "test": "digital-vite-ci-test",
    "test:all": "vitest run --coverage",
    "test:related": "vitest related --run --passWithNoTests",
    "tsc": "tsc -v && tsc",
    "vitest": "vitest run --coverage",
    "vitest:ui": "vitest --ui"
  },
  "dependencies": {
    "@amcharts/amcharts5": "^5.21.2",
    "@delasport/rule-engine-ui": "3.3.17",
    "@dnd-kit/core": "^6.3.1",
    "@dnd-kit/modifiers": "^9.0.0",
    "@dnd-kit/sortable": "^10.0.0",
    "@dnd-kit/utilities": "^3.2.2",
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.1",
    "@hookform/resolvers": "^5.9.2",
    "@mui/icons-material": "^9.5.0",
    "@mui/material": "^9.5.0",
    "@mui/x-data-grid": "^9.14.0",
    "@mui/x-date-pickers": "^9.14.0",
    "@mui/x-tree-view": "^9.14.0",
    "@reduxjs/toolkit": "^2.13.0",
    "@sentry/react": "^10.76.2",
    "@tanstack/react-table": "^9.3.1",
    "dayjs": "^1.11.23",
    "dompurify": "^3.4.17",
    "i18next": "^26.5.2",
    "jodit": "^4.18.4",
    "jodit-react": "^5.8.4",
    "lodash": "^4.18.1",
    "react": "^19.3.1",
    "react-dom": "^19.3.1",
    "react-dropzone": "^20.1.4",
    "react-easy-crop": "^6.2.4",
    "react-hook-form": "^7.90.0",
    "react-i18next": "^17.1.0",
    "react-icons": "^5.7.0",
    "react-redux": "^9.3.0",
    "react-router-dom": "^7.18.4",
    "react-toastify": "^11.1.0",
    "react-use": "^17.6.1",
    "react-window": "^2.4.1",
    "zod": "^4.6.7"
  },
  "devDependencies": {
    "@delasport/digital-eslint-core-ui": "2.15.13",
    "@delasport/digital-vite-bundle-kit-ui": "1.4.20",
    "@ls-lint/ls-lint": "^2.3.2",
    "@sentry/vite-plugin": "^5.4.1",
    "@testing-library/jest-dom": "^7.0.1",
    "@testing-library/react": "^16.3.3",
    "@testing-library/user-event": "^14.6.8",
    "@types/dompurify": "^3.2.0",
    "@types/lodash": "^4.17.26",
    "@types/react": "^19.3.0",
    "@types/react-dom": "^19.3.0",
    "@types/redux-mock-store": "^1.5.0",
    "@vitejs/plugin-react": "^6.1.2",
    "@vitest/coverage-v8": "^5.0.5",
    "@vitest/ui": "^5.0.5",
    "autoprefixer": "^10.6.1",
    "husky": "^9.1.7",
    "jsdom": "^30.1.3",
    "lint-staged": "^17.6.0",
    "typescript": "^6.0.3",
    "vite": "^8.3.4",
    "vitest": "^5.0.5"
  },
  "engines": {
    "node": ">= 24.11.1",
    "npm": ">= 11.6.2",
    "yarn": "Please use npm instead of yarn.",
    "pnpm": "Please use npm instead of pnpm."
  },
  "husky": {
    "hooks": {
      "pre-commit": "lint-staged",
      "pre-push": "npm run test"
    }
  },
  "lint-staged": {
    "src/**/*.{js,jsx,ts,tsx,json}": [
      "lint:fix"
    ],
    "src/**/*.{js,jsx,ts,tsx,json,css,md}": [
      "format:fix"
    ],
    "*.json": [
      "prettier --write"
    ]
  }
}
